import React, { type ReactNode, useCallback, type FC } from 'react';
import { useIntl } from 'react-intl-next';
import Button from '@atlaskit/button';
import ErrorIcon from '@atlaskit/icon/glyph/error';
import { Box, Inline } from '@atlaskit/primitives';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { Message } from '@atlassian/help-center-conversation';
import { useLastHelpseekerMessage, useActions } from '../../../../controllers/conversation-store';
import messages from './messages';

export const ErrorMessage: FC<{ hasRetryAction: boolean }> = ({ hasRetryAction }) => {
    const { formatMessage } = useIntl();
    const { addMessage } = useActions();
    const lastHelpseekerMessage = useLastHelpseekerMessage();

    const handleTryAgain = useCallback(() => {
        if (lastHelpseekerMessage) {
            addMessage(lastHelpseekerMessage.message.content);
        }
    }, [lastHelpseekerMessage, addMessage]);

    const tryAgainLink = useCallback(
        (chunks: ReactNode) => {
            return (
                <Button appearance="link" onClick={handleTryAgain} spacing="none">
                    {chunks}
                </Button>
            );
        },
        [handleTryAgain]
    );

    const messageContent = (
        <Inline alignBlock="center" space="space.100">
            <ErrorIcon size="medium" primaryColor={token('color.icon.danger', colors.R400)} label="" />
            <Box as="span">
                {hasRetryAction
                    ? formatMessage(messages.errorMessageContentWithRetryNonFinal, { link: tryAgainLink })
                    : formatMessage(messages.errorMessageContentNonFinal)}
            </Box>
        </Inline>
    );

    return (
        <Message
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            borderColor="grey"
            fullWidth
            content={messageContent}
            position="left"
        />
    );
};
